import AppReadMore from '../app-read-more/index.vue'

export default
{
    components:
    {
        AppReadMore
    },

    props:
    {
        content: { type: Object, default: null }
    },

    data()
    {
        return {
            readmoreHeight: 0,
            activeVariantIndex: -1,
            buyBtnHref: ''
        }
    },

    created()
    {
        this.eventHub.$on('window:resize', this.onResize)
    },

    mounted()
    {
        this.$table = this.$el.querySelector('.js-table')
        this.$colLeft = this.$el.querySelector('.js-col-left')
        this.$colRight = this.$el.querySelector('.js-col-right')

        this.onResize()
        this.$emit('page:ready')
    },

    destroyed()
    {
        this.eventHub.$off('window:resize', this.onResize)
    },

    methods:
    {
        onResize()
        {
            this._colLeftHeight = this.$colLeft.offsetHeight
            this._colRightHeight = this.$colRight.offsetHeight

            this._tableHeight = this.$table ? this.$table.offsetHeight : 0

            if(this._colRightHeight > this._colLeftHeight)
            {
                this.readmoreHeight = this._colRightHeight - this._colLeftHeight - this._tableHeight
            }
        },

        onVariantChange(index)
        {
            this.activeVariantIndex = index
            this.$el.classList.remove('has-error')

            this.buyBtnHref = this.content.couvertures[index].lien_paypal
        },

        onSelectChange(event)
        {
            this.$el.classList.remove('has-error')

            this.buyBtnHref = event.target.options[event.target.selectedIndex].value
            this.activeVariantIndex = event.target.options[event.target.selectedIndex].index - 1
        },

        onBuy(event)
        {
            const href = event.currentTarget.getAttribute('data-href')

            console.log('onBuy', href)

            if(href === '')
            {
                this.$el.classList.add('has-error')
            }
            else
            {
                this.$el.classList.remove('has-error')
                window.open(href, '_blank')
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-page-product/script.js